import { KpiCard } from './KpiCard';
import {
  useAcceptanceRate,
  useCoverageRate,
  useIncidentRate,
  useLateCancellationRate,
  useNoShowPassengerRate,
  usePunctualityRate,
  useSecurityIncidentRate,
  useServiceRate,
} from '../../services/api/hooks/useDashboardRates';
import { useFilterStore } from '../filters/filterStore';

export const KpiGrid = () => {
  const { scopes, dateRange } = useFilterStore();
  const input = { scopes, dateRange };

  const coverage = useCoverageRate(input);
  const acceptance = useAcceptanceRate(input); // alias coverage (cf. spec §5.D RG-KPI-1)
  const punctuality = usePunctualityRate(input);
  const incident = useIncidentRate(input);
  const security = useSecurityIncidentRate(input);
  const service = useServiceRate(input);
  const lateCancellation = useLateCancellationRate(input);
  const noShow = useNoShowPassengerRate(input);

  return (
    <section aria-label="Indicateurs clés" className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
      <KpiCard label="Taux de couverture" data={coverage.data} isLoading={coverage.isLoading} />
      <KpiCard label="Taux d'acceptation" data={acceptance.data} isLoading={acceptance.isLoading} />
      <KpiCard label="Ponctualité" data={punctuality.data} isLoading={punctuality.isLoading} />
      <KpiCard label="Taux d'incident" data={incident.data} isLoading={incident.isLoading} />
      <KpiCard label="Incidents sécurité" data={security.data} isLoading={security.isLoading} />
      <KpiCard label="Taux de service" data={service.data} isLoading={service.isLoading} />
      <KpiCard label="Annulation tardive" data={lateCancellation.data} isLoading={lateCancellation.isLoading} />
      <KpiCard label="No-show passager" data={noShow.data} isLoading={noShow.isLoading} />
    </section>
  );
};
